// Components
const SocialClubFeeds = () => import(/* webpackPrefetch: true, webpackChunkName: "social-club-feeds"*/ '@/app/views/main-view/social-club/components/social-club-feeds/social-club-feeds.vue');
const ModalSocialReportContent = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-social-report-content"*/ '@/app/views/main-view/social-club/components/modals/modal-social-report-content/modal-social-report-content.vue');

// Services
import PostService from '@/app/services/main/post/post-service';
import ClubsService from '@/app/services/main/club/club-service';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

// Mixins
import { userMixins } from '@/app/mixins/modules/user-mixins';
import { switchPetMixins } from '@/app/mixins/modules/switch-pet-mixins';


export default {
	name: 'SocialPostContainer',
	components: {
		SocialClubFeeds,
		ModalSocialReportContent
	},
	mixins: [
		userMixins,
		switchPetMixins
	],
	data() {
		return {
			isAPILoading: false,
			feeds: [],
			reportContent: null,
		}
	},
	computed: {
		getActiveGroup() {
			return this.$store.getters.getActiveGroup;
		},
		getPostContent() {
			return this.$store.getters.getPostContent;
		}
	},
	mounted() {
		this.setActiveGroup();
	},
	methods: {
		backToGroup() {
			this.$store.commit('setPostContent', null);
			if(this.getActiveGroup.id === 1001) {
				this.$router.push('/social');
			} else {
				this.$router.push('/social/group');
			}
		},
		updatePostCallback(updatedPost) {
			this.feeds = this.feeds.map((post) => {
				if (updatedPost.id === post.id) {
					return updatedPost;
				}

				return post;
			});
		},
		async deletePostCallback(postId) {
			const res = await PostService.deletePost(postId);

			if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
				this.feeds = this.feeds.filter(({ id }) => id !== postId);
				this.showCustomSuccessToast('Post has been deleted.');
			} else {
				const { ERROR_DELETE_POST } = this.toastMessages.post();
				this.showAPIErrorToast(ERROR_DELETE_POST, res);
			}
		},
		showReportContentModal(content) {
			this.reportContent = content;
			this.$refs.socialReportContentModal.openModal();
		},
		setActiveGroup() {
			if(this.$route.query.id && this.$route.query.groupId){
				let group = {};			

				const queryParams = {
					f_groupId: this.$route.query.groupId
				};

				ClubsService.getGroups(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.group = res.data.data;
						// set activeGroupId
						this.$store.commit('setActiveGroup', group[0]);
					} else {
						this.showCustomErrorToast(res.data.errors[0].message, null, true);
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
				});

				PostService.getPostById(this.$route.query.id)
					.then(res => {
						if (res.status === STATUS_CODES.SUCCESS) {
							// set post content
							this.$store.commit('setPostContent', res.data);
						} 
					});
				this.$router.push('/post');
			}
		}
	}
}